















































import { Component, Vue, Prop, Provide, Watch } from "vue-property-decorator";
import { State, Getter, Action, namespace } from "vuex-class";
import ValidationService from "../../services/validation.service";
import VeeValidate from "vee-validate";
import container from "../../inversify.config";
import { UpdatePassword } from "../../models/authentication/update-password.model";
import UserAlert from "@/components/UserAlert.vue";

import { IPortalUser } from "../../models/interfaces/authentication/portal-user.model.interface";

const UserModule = namespace("userModule");

@Component({
  components: {
    UserAlert
  }
})
export default class Profile extends Vue {
  @UserModule.Getter public user: IPortalUser;
  @UserModule.Action public updatePassword;

  @Provide() public items: IPortalUser[] = [];

  @Provide()
  public columns = [
    { key: "fullName" },
    { key: "emailAddress" },
    { key: "company" },
    { key: "role.name", label: "Role" },
    { key: "password" }
  ];

  private isBusy: boolean = false;
  private updatePasswordModel = {} as UpdatePassword;

  get getUser() {
    return this.user;
  }

  public getValidationClass(fieldName: string) {
    return container
      .get<ValidationService>(ValidationService)
      .getValidationClass(this.$validator, fieldName);
  }

  public created() {
    this.items = [this.user];
  }

  private submitForm() {
    this.$validator.validateAll().then((valid) => {
      if (valid) {
        this.isBusy = true;
        this.updatePasswordModel.emailAddress = this.getUser.emailAddress;
        this.updatePassword(this.updatePasswordModel).then((result) =>
          this.processUpdatePasswordResult(result)
        );
      }
    });
  }

  private processUpdatePasswordResult(value) {
    if (value.success) {
      this.updatePasswordModel.currentPassword = "";
      this.updatePasswordModel.password = "";
      this.updatePasswordModel.confirmPassword = "";
    }
  }
}
